import React, { useEffect, useState } from "react";
import { LoadingIcon } from "../../../../components";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";

import isBetween from "dayjs/plugin/isBetween";
import { getForecastedPlots } from "../../../../utils/api";
import { Graphs } from "./Graphs";
import ConfigTable from "./ConfigTable";

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

const DashboardContent = ({
  currentOrg,
  currentSite,
  dropdownLoading,
  dateList,
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
  currentDate,
}) => {
  const isImperial = currentSite?.metadata?.siteConfig?.display_units === "imperial";
  const [forecastData, setForecastData] = useState(null);
  const [forecastDataLoading, setForecastDataLoading] = useState(false);

  const [totalActualHeadCount, setTotalActualHeadCount] = useState(null);
  const [specData, setSpecData] = useState([]);

  useEffect(() => {
    if (siteMetadata && currentCrop && currentGreenhouse && currentPlot) {
      const headCount =
        siteMetadata?.[currentGreenhouse.name]?.[currentPlot.name]?.[
          "actual_headcount"
        ];

        let harvestedHeadCount =
        siteMetadata?.[currentGreenhouse.name]?.[currentPlot.name]?.[
          "harvested_headcount"
        ];

        if(harvestedHeadCount == undefined || harvestedHeadCount == null){
          harvestedHeadCount = 0 
        }

      if (headCount) {
        setTotalActualHeadCount(headCount - harvestedHeadCount);
      } else {
        setTotalActualHeadCount(0);
      }
    }
  }, [siteMetadata, currentCrop, currentGreenhouse, currentPlot]);

  useEffect(() => {
    if (
      !(
        currentOrg &&
        currentSite &&
        currentCrop &&
        currentGreenhouse &&
        currentPlot &&
        currentDate &&
        !dropdownLoading
      )
    ) {
      return;
    }
    fetchForecastData();
  }, [
    currentOrg,
    currentSite,
    currentCrop,
    currentGreenhouse,
    currentPlot,
    currentDate,
    dropdownLoading,
  ]);

  const fetchForecastData = async () => {
    setForecastDataLoading(true);
    const resp = await getForecastedPlots(
      currentOrg,
      currentSite.id,
      currentCrop.id,
      [currentGreenhouse.id],
      [currentPlot.id],
      currentDate,
    );
    setForecastData(resp.data.data?.[0] || null);
    // setForecastData(dummyData1984SectionA);
    setForecastDataLoading(false);
  };

  return (
    <>
      {dropdownLoading || forecastDataLoading ? (
        <LoadingIcon height="200px" />
      ) : (
        <div className="w-full flex flex-col items-center">
          {/*<h1> Stand Count : {totalActualHeadCount}</h1>*/}
          <ConfigTable
            forecastedData={forecastData}
            setForecastData={setForecastData}
            currentOrg={currentOrg}
            currentSite={currentSite}
            currentCrop={currentCrop}
            currentGreenhouse={currentGreenhouse}
            currentPlot={currentPlot}
            currentDate={currentDate}
            siteMetadata={siteMetadata}
            totalActualHeadCount={totalActualHeadCount}
            specData={specData}
            setSpecData={setSpecData}
            isImperial={isImperial}
          ></ConfigTable>
          <Graphs forecastData={forecastData} specData={specData} currentSite={currentSite}></Graphs>
        </div>
      )}
    </>
  );
};

export default DashboardContent;
